import { Logger, PageHistoryManager } from 'wdc-cube';
import { keepOnlySealed } from './history-codec';
const LOG = Logger.get('Mormaii.SealedHistory');
/**
 * O gerenciador de historico que so aceita endereco produzido por esta aplicacao.
 *
 * Sem isto, a cifra protegeria a LEITURA e nao a escrita. O `wdc-cube` aceita
 * endereco em texto claro de proposito - e o que faz um bookmark antigo continuar
 * abrindo, e o que torna adotar um codec uma decisao endereco a endereco. Aqui essa
 * tolerancia nao serve: quem quisesse comandar o estado bastaria digitar
 * `#/shared-history?codigo=outro`.
 *
 * A regra e uma so: ou a query INTEIRA e o envelope, ou ela nao existe. O caminho e
 * preservado, porque nunca foi segredo - a tela abre no estado padrao em vez de dar
 * erro.
 *
 * ## Por que olhar o endereco CRU
 *
 * O `location` da base ja devolve texto claro: e ali que o codec e aplicado, e o
 * framework inteiro depende disso (ele decide "o endereco mudou?" comparando
 * strings, e texto cifrado nao serviria). Entao perguntar ao `super.location` se
 * veio selado e impossivel - ele responde a mesma coisa nos dois casos. A pergunta
 * tem de ser feita sobre o que esta na barra, e a resposta vem do `isEnvelope` da
 * propria base, para que o formato do envelope continue sendo assunto dela.
 *
 * ## Ate onde isso vale
 *
 * Na area restrita a chave e por usuario e vem do servidor: ninguem forja endereco
 * para a sessao de outra pessoa. Na area publica a chave mora no bundle, entao
 * recusar texto claro eleva a barra de "digitar na barra de enderecos" para "ler o
 * bundle e usar o codec" - o que e real, mas NAO e uma fronteira de seguranca. Quem
 * autoriza continua sendo o servidor, e validar na chegada continua obrigatorio.
 */
export class SealedHistoryManager extends PageHistoryManager {
    constructor(useHash = false) {
        super(useHash);
        this.warned = false;
        this.useHash = useHash;
    }
    get location() {
        const plain = super.location;
        // Sem codec nao ha o que exigir: e o caso de um servidor sem o segredo
        // mestre, em que a aplicacao segue funcionando em texto claro.
        if (!this.codec) {
            return plain;
        }
        const rawQueryText = this.rawQuery();
        const accepted = keepOnlySealed(plain, rawQueryText, this.isEnvelope(rawQueryText));
        if (accepted !== plain) {
            this.warnOnce(rawQueryText);
        }
        return accepted;
    }
    /** A query como esta na barra, antes de qualquer decifragem. */
    rawQuery() {
        const address = this.useHash
            ? window.location.hash.replace(/^#/, '')
            : window.location.pathname + window.location.search;
        const cut = address.indexOf('?');
        return cut < 0 ? '' : address.slice(cut + 1);
    }
    /**
     * Um aviso por endereco recusado, e nao um por leitura.
     *
     * `location` e lido a cada evento de historico; sem isto, um endereco recusado
     * encheria o console e esconderia o que importa.
     */
    warnOnce(query) {
        if (this.warned) {
            return;
        }
        this.warned = true;
        LOG.warn(`Endereço não produzido por esta aplicação: os parâmetros foram descartados (${query.length} car.)`);
    }
}
//# sourceMappingURL=sealed-history-manager.js.map